import {
  HStack,
  Text,
  Icon,
  VStack,
  Input,
  InputGroup,
  Box,
  useDisclosure,
  InputRightElement,
  SlideFade,
  Divider,
} from '@chakra-ui/react';
import { useState } from 'react';
import { IoMdPin } from 'react-icons/io';
import { IoSearchOutline, IoArrowBack, IoCloseCircle } from 'react-icons/io5';
import LocationList from './LocationList';
import SearchList from './SearchList';

import useReturnContainerPoints from '../../hooks/useReturnContainerPoints';

// 搜尋歸還餐盒地點
export default function SearchLocation() {
  const [isSearch, setIsSearch] = useState<boolean>(false);
  const returnContainerPoints = useReturnContainerPoints();

  const { isOpen, onToggle } = useDisclosure({ isOpen: true });

  const [searchInput, setSearchInput] = useState<string>('');

  const handleClearInput = () => {
    setSearchInput('');
  };

  const handleOpenSearchBar = (open: boolean) => {
    onToggle();
    setSearchInput('');
    setIsSearch(open);
  };

  const openedStyle = {
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    maxWidth: '200rem',
    opacity: 1,
    transition: 'max-width 0.5s, opacity 0.5s',
  };

  const closedStyle = {
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    maxWidth: '5rem',
    opacity: 1,
    transition: 'max-width 0.02s, opacity 0.02s',
  };

  const openedTextStyle = {
    maxWidth: '0rem',
    display: 'none',
    opacity: 0,
    transition: 'min-width 0.2s, opacity 0.2s , display 0.2s',
  };

  const closedTextStyle = {
    maxWidth: '3rem',
    display: 'unset',
    opacity: 1,
    transition: 'max-width 0.5s, opacity 0.2s, display 0.2s',
  };

  return (
    <VStack py={4} spacing={4} align="stretch">
      <HStack align="center" spacing={3} justify="space-between" w="full" pos="relative">
        {isSearch ? (
          <Icon
            color="gray.500"
            as={IoArrowBack}
            onClick={() => handleOpenSearchBar(false)}
            boxSize="1.5rem"
          />
        ) : (
          <HStack>
            <Icon color="secondary" as={IoMdPin} boxSize="1.25rem" />
            <Text fontSize="sm" color="secondary">
              全部回收點({returnContainerPoints.length})
            </Text>
          </HStack>
        )}
        {/* 
        <HStack
          as="button"
          onClick={() => handleOpenSearchBar(true)}
          borderWidth="1px"
          borderColor="primary"
          py={1}
          px={2}
          borderRadius="5px"
          maxW="3rem"
          overflow="hidden"
          w={isSearch ? 'full' : 'auto'}
          align="center"
          spacing={1}
          {...(isSearch ? openedStyle : closedStyle)}
        >
          <Text
            fontSize="sm"
            color="primary"
            align="center"
            minW="2rem"
            {...(isSearch ? openedTextStyle : closedTextStyle)}
          >
            尋找
          </Text>
          <Icon color="primary" as={IoSearchOutline} boxSize="1.25rem" />

          <InputGroup size="xs">
            <Input
              focusBorderColor="none"
              value={searchInput}
              border="none"
              placeholder="輸入您的位址尋找最近的取餐地點"
              onChange={(e) => setSearchInput(e.target.value)}
            />

            <InputRightElement
              children={
                <Icon
                  as={IoCloseCircle}
                  onClick={handleClearInput}
                  _hover={{ cursor: 'pointer' }}
                  display={searchInput !== '' ? '' : 'none'}
                  color="gray.400"
                  boxSize="1.5rem"
                />
              }
            />
          </InputGroup>
          <SlideFade in={!!searchInput}>
            <VStack
              divider={<Divider />}
              spacing={0}
              align="stretch"
              bg="white"
              pos="absolute"
              w="full"
              top="2.1rem"
              left="2rem"
              zIndex={1}
              autoComplete="off"
              textAlign="start"
              fontSize="sm"
            >
              <Box
                mr={8}
                borderX="1px solid #F2F2F2"
                borderBottom="1px solid #F2F2F2"
                _hover={{
                  cursor: 'pointer',
                  bg: 'gray.200',
                }}
                p={2}
              >
                <Text>台北市大安區大安路88號</Text>
              </Box>
              <Box
                mr={8}
                borderX="1px solid #F2F2F2"
                borderBottom="1px solid #F2F2F2"
                _hover={{
                  cursor: 'pointer',
                  bg: 'gray.200',
                }}
                p={2}
              >
                <Text>台北市大安區大安路48號</Text>
              </Box>
              <Box
                mr={8}
                borderX="1px solid #F2F2F2"
                borderBottom="1px solid #F2F2F2"
                _hover={{
                  cursor: 'pointer',
                  bg: 'gray.200',
                }}
                p={2}
              >
                <Text>台北市大安區大安路68號</Text>
              </Box>
            </VStack>
          </SlideFade>
        </HStack> */}
      </HStack>

      {isSearch ? (
        <SearchList input={searchInput} />
      ) : (
        <SlideFade in={isOpen} offsetY="0px" offsetX="20px">
          <LocationList returnContainerPoints={returnContainerPoints} />
        </SlideFade>
      )}
    </VStack>
  );
}
